// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2gIAa","title":"Images90_title__3edgZ","images":"Images90_images__NkI_w"};